import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import moment from 'moment';
import cleanHtml from 'utils/janitor';
import { replaceShortcodes } from 'utils/emojify';

class TimelineItem extends React.Component {

    componentDidMount() {
        var self = this,
            date = self.props.detail.date,
            today;

        if (!date) {
            return;
        }

        if (self.props.location.query && self.props.location.query.day) {
            today = moment(self.props.location.query.day);
        }
        else {
            today = moment();
        }

        date = moment(date, 'MMMM DD, YYYY');

        if (date.isSame(today, 'day')) {
            ReactDOM.findDOMNode(self).scrollIntoView(true);
        }
    }

    render () {
        var self = this,
            detail = self.props.detail,
            date,
            dayType,
            airports,
            destinations,
            lodging,
            activities,
            leftPanel, rightPanel;

        if (detail.date) {
            date = <div className="timeline-list-item-header" dangerouslySetInnerHTML={ { __html: cleanHtml(detail.date) } }></div>;
        }

        if (detail.dayType) {
            dayType = <div className="timeline-list-item-content-center" dangerouslySetInnerHTML={ { __html: replaceShortcodes(cleanHtml(detail.dayType)) } }></div>;
        }

        if (detail.airports && detail.airports.length) {
            airports = <div className="timeline-list-item-content-center"
                dangerouslySetInnerHTML={ { __html: cleanHtml(detail.airports.join(' <i class="fa fa-arrow-circle-o-right"></i> ')) } }></div>;
        }

        if (detail.destinations && detail.destinations.length) {
            let destinationList = detail.destinations.map((d, i, arr) => {
                let divider = i < arr.length - 1 && (<span> <i className="fa fa-arrow-circle-o-right"></i> </span>); 

                if (!d.id) {
                    return (
                        <span key={ i }>
                            { replaceShortcodes(cleanHtml(d)) }
                            { divider }
                        </span>
                    );
                }

                return (
                    <span key={ d.id }>
                        <a className="timeline-list-item-hidden-link" href={ d.url } target="_blank" title={ 'Visit ' + d.name + ' on Google Maps' }>
                            { replaceShortcodes(cleanHtml(d.name)) }
                        </a>
                        { divider }
                    </span>
                );
            });

            destinations = <header className="panel-header">{ destinationList }</header>;
        }

        if (detail.lodging && detail.lodging.id) {
            lodging = (
                <p>
                    <i className="fa fa-bed"></i>
                    &nbsp;
                    <a className="timeline-list-item-subtle-link" href={ detail.lodging.url } target="_blank" title={ 'Visit ' + detail.lodging.name + ' on Google Maps' }>{ detail.lodging.name }</a>
                </p>
            );
        }
        else if (detail.lodging) {
            lodging = (
                <p>
                    <i className="fa fa-bed"></i>
                    &nbsp;
                    { detail.lodging }
                </p>
            );
        }

        if (detail.activities && detail.activities.length) {
            activities = detail.activities.map((activity, key) => {
                if (!activity.id) {
                    return <li key={ key } dangerouslySetInnerHTML={ { __html: replaceShortcodes(cleanHtml(activity)) } } />
                }

                return (
                    <li key={ key }>
                        <a className="timeline-list-item-subtle-link" href={ activity.url } target="_blank" title={ 'Visit ' + activity.name + ' on Google Maps' }>
                            { replaceShortcodes(cleanHtml(activity.name)) }
                        </a>
                    </li>
                );
            });
        }

        if (destinations || lodging) {
            leftPanel = (
                <div className="panel timeline-list-item-content-left">
                    { destinations }

                    { lodging }
                </div>
            );
        }

        if (activities) {
            rightPanel = (
                <div className="panel timeline-list-item-content-right">
                    <ul className="timeline-list-item-activities">
                        { activities }
                    </ul>
                </div>
            );
        }

        return (
            <div className="timeline-list-item">
                { date }
                { dayType }
                { airports }

                { leftPanel }
                { rightPanel }
            </div>
        );
    }
};

export default TimelineItem;


// WEBPACK FOOTER //
// ./src/app/components/timeline/timelineItem.jsx